( function($) {

    /**
     * iLightbox Testing
     * - Avada loads this light box plugin. It must be enabled in the options in order to be freely used.
     * ***
     * - Documentation: http://ilightbox.net/documentation.html
     * - You can also go here: http://ilightbox.net/index.html#advanced_mixed 
     * -- inspect the click event for a#mixed_events to open up the loaded script, in the source window, with all the iLightBox functions for each example
     * - Skins: light, dark, mac, metro-black, metro-white, parade, smooth
     * --- The skin that is selected in the global Avada options will be the only one available. Ac custom skin
     * --- can also be created so we can define our own styling.
     */
    if ( $('#click-ilightbox').length !== 0 ) {

        $('#click-ilightbox').click( function(e) {
            e.preventDefault();
            
            //Single Image
            //$.iLightBox('https://hg.stratam.app/wp-content/uploads/2024/09/Mask-Group-113.jpg');

            //iFrame Video - YouTube
            // $.iLightBox(
            //     [
            //         {
            //             URL: "https://www.youtube.com/watch?v=LXb3EKWsInQ",
            //             type: 'iframe',
            //             title: 'Test Youtube',
            //             caption: 'Test Caption',
            //             options: {
            //                 width: 640,
            //                 height: 272
            //             }
            //         }
            //     ],
            //     {
            //         skin: 'metro-black',
            //     }
            // );

            //Video - Hosted
            // $.iLightBox(
            //     [
            //         {
            //             URL: "https://hg.stratam.app/wp-content/uploads/2024/08/Hg-About-Us.mp4",
            //             type: 'video',
            //             title: 'Test Youtube',
            //             caption: 'Test Caption',
            //             options: {
            //                 width: 640,
            //                 height: 272
            //             }
            //         }
            //     ],
            //     {
            //         skin: 'metro-black',
            //     }
            // );

            //Gallery Setup
            const galleryArr = [];

            //Get all images and push into our setup array
            if ( $('img[data-rel="iLightbox-gallery-01"]').length !== 0 ) {
                const galleryImg = $('img[data-rel="iLightbox-gallery-01"]');

                galleryImg.each( function(e) {
                    galleryArr.push({
                        URL: $(this).attr('src'),
                        options: {
                            thumbnail: $(this).attr('src'),
                        },
                        type: "image",
                        caption: $(this).attr('title')
                    });
                });
            }

            //Pass array of images and skin setting into iLightBox object
            $.iLightBox(galleryArr, {skin: 'metro-black'});
        });
    }

})(jQuery);